export const LOCALE_COOKIE_NAME = "rallly_locale";
